/* eslint-disable jsdoc/require-file-overview -- When touching please add documentation. */
import Vue from 'vue';
import Vuex from 'vuex';
import { getStoreBuilder } from '@codegrade/vuex-typex';
import { signal } from '@/utils';
import * as persist from './persist';
/** @inheritdoc */
export { UserStore } from './modules/user';
/** @inheritdoc */
export { NotificationStore } from './modules/notification';
/** @inheritdoc */
export { FeedbackStore } from './modules/feedback';
/** @inheritdoc */
export { PeerFeedbackStore } from './modules/peer_feedback';
/** @inheritdoc */
export { AssignmentsStore } from './modules/assignments';
/** @inheritdoc */
export { SubmissionsStore } from './modules/submissions';
/** @inheritdoc */
export { CoursesStore } from './modules/courses';
/** @inheritdoc */
export { CourseRestrictionsStore } from './modules/course-restrictions';
/** @inheritdoc */
export { SiteSettingsStore } from './modules/siteSettings';
/** @inheritdoc */
export { UIPrefsStore } from './modules/ui_prefs';
/** @inheritdoc */
export { TenantsStore } from './modules/tenants';
/** @inheritdoc */
export { FileTreeStore } from './modules/file_trees';
/** @inheritdoc */
export { GradersStore } from './modules/graders';
/** @inheritdoc */
export { AutoTestStore } from './modules/autotest';
/** @inheritdoc */
export { CodeStore } from './modules/code';
/** @inheritdoc */
export { PreferenceStore } from './modules/preference';
/** @inheritdoc */
export { EditorSessionsStore } from './modules/editor-sessions';
/** @inheritdoc */
export { SAFEStore } from './modules/safe';
/** @inheritdoc */
export { SectionsStore } from './modules/sections';
/** @inheritdoc */
export { ATv2OutputStore } from './modules/atv2_output';
/** @inheritdoc */
export { AssistantsStore } from './modules/assistants';
/** @inheritdoc */
export { JupyterStore } from './modules/jupyter';
/** @inheritdoc */
export { RubricsStore } from './modules/rubrics';
/** @inheritdoc */
export { CourseSnippetsStore } from './modules/course-snippets';
/** @inheritdoc */
export { GroupsStore } from './modules/groups';
/** @inheritdoc */
export { GroupSetsStore } from './modules/group-sets';
/** @inheritdoc */
export { PlagiarismStore } from './modules/plagiarism';
/** @inheritdoc */
export { CourseRolesStore } from './modules/course-roles';
/** @inheritdoc */
export { EnrollLinksStore } from './modules/enroll-links';
/** @inheritdoc */
export { AnalyticsStore } from './modules/analytics';
/** @inheritdoc */
export { LTIProvidersStore } from './modules/lti-providers';
/** @inheritdoc */
export { AIToolUseContextStore } from './modules/ai-tool-use-context';
Vue.use(Vuex);
const rootBuilder = getStoreBuilder();
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const store = rootBuilder.vuexStore({ strict: false });
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export function onVueCreated(vue) {
    persist.onVueCreated(vue);
}
// eslint-disable-next-line jsdoc/require-jsdoc -- When touching please add documentation.
export const disablePersistance = persist.disablePersistance;
const creatingPromise = signal.STORE_CREATED.sendPromise(store);
/** @returns A Promise that resolves when the store has been created. */
export async function waitTillStoreCreated() {
    await creatingPromise;
}
